import {Chip} from '@ds/components';
import {cn} from '@ds/helpers';
import {getStatusChipProps} from 'common/status-chip/getStatusChipProps';

type HistoryItemProps = {
  title: string;
  subtitle: string;
  state: string;
  onClick?: () => void;
  stateTitle: Record<string, string>;
  item?: unknown;
  className?: string;
};

const HistoryItem: React.FC<HistoryItemProps> = ({
  title,
  subtitle,
  state,
  onClick,
  stateTitle,
  className
}) => {
  const chipProps = getStatusChipProps(state);

  return (
    <div
      className={cn('flex flex-col bg-white px-4 py-3', className)}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onClick();
              }
            }
          : undefined
      }
    >
      <div className="flex items-center justify-between gap-3 border-b border-gray-03 pb-2">
        <div className="flex min-w-0 flex-1 flex-col">
          <span className="text-body-sm-emphasis text-neutral-fg">{title}</span>
          <span className="text-body-sm text-gray-07">{subtitle}</span>
        </div>
        <Chip
          label={stateTitle[state]}
          variant={chipProps.variant}
          color={chipProps.color}
          size="sm"
          interactive={false}
        />
      </div>
    </div>
  );
};

export default HistoryItem;
